var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLitterExpenses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "litter_expenses") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "litter_expenses"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40.47,
    y: 1.59,
    width: 521.46,
    height: 597.98,
    rx: 51.27,
    fill: "#febe10"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.92,
    y: 74.18,
    width: 363.95,
    height: 147.6,
    rx: 24,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.92,
    y: 298,
    width: 72.79,
    height: 72.79,
    rx: 12,
    fill: "#fffbc5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.5,
    y: 298,
    width: 72.79,
    height: 72.79,
    rx: 12,
    fill: "#fffbc5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.5,
    y: 443.57,
    width: 72.79,
    height: 72.79,
    rx: 12,
    fill: "#fffbc5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.08,
    y: 298,
    width: 72.79,
    height: 218.37,
    rx: 12,
    fill: "#fffbc5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.92,
    y: 443.57,
    width: 72.79,
    height: 72.79,
    rx: 12,
    fill: "#fffbc5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLitterExpenses);
export default __webpack_public_path__ + "static/media/litter_expenses.8caa6772d3979799d6809983418a5f72.svg";
export { ForwardRef as ReactComponent };